import React, { useState } from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import logoimg from '../Images/sumukhalogo.png';
import foterlogo from '../Images/irs.png';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';

 const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState('');
  const [emaill, setEmaill] = useState('info@sumukhataxfilers.com');

  const handleEmailClickk = () => {
    window.location.href = `mailto:${emaill}`;
  };

  const handleSubscribe = async () => {
    try {
      const response = await fetch('http://localhost:3002/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setIsSubscribed(true);
      } else {
        const data = await response.json();
        setSubscriptionError(data.message);
      }
    } catch (error) {
      console.error('Error subscribing:', error);
    }
  };

  return (
    <div>
      <footer className="footer-main-container">
        <div className="footer-primary">
          <div className="footer-column footer-about">
            <div className="footer-logo-container">
              <img src={logoimg} alt="Sumukha Tax Filers. Logo" className="footer-logo-img" />
              <div className="footer-logo-text">
                <h5>Sumukha Tax Filers.</h5>
                <p className="footer-tagline">Simplifying Taxes Empowering Success</p>
              </div>
              <div className="footer-social-icons">
              <img src={foterlogo} alt="IRS Logo" className="footer-logo" />
             
            </div>
            </div>
          </div>

          <div className="footer-column footer-links">
            <h8 className="footer-quick-links-title">Quick Links</h8>
            <div className="footer-quick-links-wrapper">
              <ul className="footer-ul">
         
                <li><Link to="/signup">Register Now</Link></li>
                <li><Link to="/refundstatus">Refund Status</Link></li>
            


                <li><Link to="/refundpolicy">Refund Policy</Link></li>
                <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms and Conditions</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-column footer-get-in-touch">
            <h8 className="footer-quick-links-title">Get in Touch</h8>
            <p className="footer-phone-number">Phone Number: +1 (302)-200-2836</p>
            <p className="footer-phone-number">16192 COASTAL HWY<br></br> LEWES DE 19958</p>
            <p onClick={handleEmailClickk}>Email: {emaill}</p>
            <div className="footer-social">
  <FaLinkedinIn />
  <FaFacebookF />
  <FaInstagram />
  <FaTwitter />
</div>

           
          </div>
        </div>

        <div className="footer-copyright">
          <p>&copy; 2024 Sumukha Tax Filers| All Rights Reserved</p>
         
        </div>
      </footer>
    </div>
  );
};
export default Footer;